import { put, call, select, takeLeading } from 'redux-saga/effects';

import { Routes } from 'constants/routes';
import { Roles } from 'constants/roles';

import * as $app from 'modules/app';
import * as $nav from 'modules/navigation';
import * as $ui from 'modules/ui';
import * as $arts from 'modules/arts';
import { UI } from 'modules/ui';
import * as api from '../api';
import * as actions from '../actions';
import * as selectors from '../selectors';

const fetchAnonymousToken = function* () {
  const apiKey = yield select(selectors.getApiKey);
  const deviceID = yield select(selectors.getDeviceId);
  const token = yield call(api.fetchToken, apiKey, deviceID);
  return token;
};

const authenticateUser = function* (email, password) {
  const user = yield call(api.fetchUserToken, email, password);
  return user;
};

const signup = function* ({ payload }) {
  yield put($ui.setTrue(UI.Auth.IsLoading)());

  try {
    const token = yield call(fetchAnonymousToken);
    const signupRequestOptions = { token };

    const { email, name, password } = payload;
    const userRoles = [Roles.Artist];
    const signupData = { email, password, name, userRoles };

    yield call(api.signup, signupData, signupRequestOptions);

    yield put($app.reset());

    const user = yield call(authenticateUser, email, password);
    yield put(actions.setToken(user.Token));
    yield put(actions.setUserEmail(email));
    yield put(actions.setCurrentUser(user));

    yield put($arts.createDefaultArtset());

    yield put($app.updateOnboardingSteps());

    yield put($nav.navigate(Routes.Signin));
  } catch ({ message }) {
    yield put($ui.setUi(UI.Auth.Signup.ErrorMessages, [message]));
  } finally {
    yield put($ui.setFalse(UI.Auth.IsLoading)());
  }
};

export const signupSaga = function* () {
  yield takeLeading(actions.signup, signup);
};
